module.exports = __webpack_public_path__ + "static/media/grpconv_101.29a5dbd1.ico";